import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CartSalesStepComponent, CustomerService, GungModalService, SalesCartConfigService } from 'gung-standard';
import { HeloJeevesSalesCartConfigService } from '../../../../services/helo-jeeves-sales-cart-config.service';

@Component({
  selector: 'helo-cart-sales-step',
  templateUrl: './helo-cart-sales-step.component.html'
})
export class HeloCartSalesStepComponent extends CartSalesStepComponent implements OnInit {
  isCustomerCreditBlocked = false;

  constructor(
    protected customerService: CustomerService,
    protected gungModalService: GungModalService,
    protected translationService: TranslateService,
    public salesCartConfigService: HeloJeevesSalesCartConfigService
  ) {
    super(salesCartConfigService);
  }

  ngOnInit(): void {
    console.log(this.checkout);

    this.customerService.getCustomer(this.checkout.deliveryCustomerId, true).subscribe(customer => {
      this.isCustomerCreditBlocked = this.getCustomerCreditBlocked(customer);
      this.onNextBtnClicked.subscribe(_ => {
        if (!this.isCustomerCreditBlocked) {
          this.stepDone.emit(this.checkout);
        } else {
          this.gungModalService.openConfirmYesNoModal(
            undefined,
            this.translationService.instant('CREDIT_BLOCKED'),
            { size: 'sm' },
            'OK',
            null
          );
        }
      });
    });
  }

  getCustomerCreditBlocked(customer): boolean {
    if (!!customer?.extra?._billingCustomer?.extra?.kus) {
      return customer.extra._billingCustomer.extra.kus.kreditsparr;
    } else {
      return customer.extra.kus.kreditsparr;
    }
  }
}
